import { useMemo } from 'react';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { buildGlobalRoleIdsSchema } from '../../UserRoles/schemas/global-role-ids.schema';

import { UserFormTab } from '../enums/tab.enum';
import { EmailSchema } from '../schemas/email.schema';
import { PersonSelectSchema } from '../schemas/person-select.schema';
import { buildRolesSchema } from '../schemas/roles.schema';
import { UserEmailFormStep } from '../steps/Email';
import { UserPersonSelectFormStep } from '../steps/PersonSelect';
import { UserRolesFormStep } from '../steps/Roles';

const WIZARD_CHILDREN = [
  <UserPersonSelectFormStep
    id={UserFormTab.PersonSelect}
    key={UserFormTab.PersonSelect}
  />,
  <UserEmailFormStep id={UserFormTab.Email} key={UserFormTab.Email} />,
  <UserRolesFormStep id={UserFormTab.Roles} key={UserFormTab.Roles} />,
];

export const useUserSteps = () => {
  const { userRoles } = useReferencesContext();

  const steps = useMemo(
    () =>
      [
        {
          id: UserFormTab.PersonSelect,
          title: 'Sélection Personne',
          isEnabled: true,
          ValidationSchema: PersonSelectSchema,
        },
        {
          id: UserFormTab.Email,
          title: 'E-mail',
          isEnabled: true,
          ValidationSchema: EmailSchema,
        },
        {
          id: UserFormTab.Roles,
          title: 'Rôles',
          isEnabled: true,
          ValidationSchema: buildRolesSchema(
            buildGlobalRoleIdsSchema(userRoles),
          ),
        },
      ] as const,
    [userRoles],
  );

  return { steps, wizardChildren: WIZARD_CHILDREN };
};
